/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IUserPageOwnProps, IUserPageStateProps, IUserPageDispatchProps, UserPage } from "../../components/user/UserPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getUserPage, UserThunkDispatch } from "source/models/store/user";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserPageOwnProps): IUserPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            usersPage: null
        };
    }
    const user = applicationState.user;
    return {
        appState: applicationState.session,
        dataId: user.page.dataId,
        usersPage: user.page.usersPage
    };
}

export function mapDispatchToProps(dispatch: UserThunkDispatch): IUserPageDispatchProps {
    return {
        onGetUsersPage: () => dispatch(getUserPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IUserPageStateProps, IUserPageDispatchProps, IUserPageOwnProps>(mapStateToProps, mapDispatchToProps)(UserPage);